import React from 'react';
import AttachmentPreview from 'flow/pages/messages/AttachmentPreview';
import { MessageContent } from 'flow/components/tickets/UseAttachmentHandler';

interface TicketInputAttachmentPreviewProps {
    attachment: MessageContent['attachment'];
    imageSrc: string | null;
    onClickRemove: () => void;
    onAspectRatioFound: (aspectRatio: number) => void;
}

const TicketInputAttachmentPreview = ({
    attachment,
    imageSrc,
    onClickRemove,
    onAspectRatioFound,
}: TicketInputAttachmentPreviewProps) => {
    if (!attachment) return null;

    return (
        <AttachmentPreview
            imageSrc={imageSrc}
            fileName={attachment.name}
            file={attachment.file}
            handleRemoveAttachment={onClickRemove}
            onAspectRatioFound={onAspectRatioFound}
        />
    );
};

export default TicketInputAttachmentPreview;
